<template xmlns:mailto="http://www.w3.org/1999/xhtml">
  <div
    class="alert alert-calendar col-md-8"
    style="font-size: 18px; text-align: center; width: 100%"
  >
    <span
      class="pull-right"
      style="margin-left: 15px; color: black; cursor: pointer; transition: 0.7s"
      onclick="this.parentElement.style.display='none';"
    >
      &times;
    </span>
    <div style="text-align: left; padding-left: 15px">
      <h3 style="text-transform: none">Cześć!</h3>
      Poniżej znajdziesz harmonogram dostaw oraz godziny pracy Biura Obsługi
      Klienta w okresie świątecznym:<br />
      <ul style="list-style: inside">
        <li><b>4 i 5 kwietnia</b>: dostawy realizujemy standardowo (posiłki doręczymy 4 kwietnia)</li>
        <li><b>6 kwietnia</b>: tego dnia nie realizujemy dostaw</li>
      </ul>
      <b>Godziny pracy Biura Obsługi Klienta:</b><br />
      <ul style="list-style: inside">
        <li><b>4 kwietnia</b>: pracujemy w godzinach 07:00-11:00</li>
        <li><b>5 i 6 kwietnia</b>: Biuro Obsługi Klienta będzie nieczynne</li>
      </ul>
      W pozostałe dni godziny pracy BOK pozostają bez zmian<br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NtfyMessageTemporary'
}
</script>
